import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import { compose } from 'recompose';

import ChatContext from '../../context/ChatContext';
import { withChatContextProviderReady } from '../../context/ChatContext/withChatContextProvider';
import {
  ChatContainer,
} from './styles';
import { chatPageConfig } from './config';

const ChatSidebarView = ({ isMobileView }) => {
  const {
    currentChatPage,
  } = useContext(ChatContext);

  const ChatView = chatPageConfig[currentChatPage].component;

  return (
    <ChatContainer>
      <ChatView isMobileView={isMobileView} />
    </ChatContainer>
  );
};

ChatSidebarView.propTypes = {
  isMobileView: PropTypes.bool,
};

ChatSidebarView.defaultProps = {
  isMobileView: false,
};

export default compose(
  withChatContextProviderReady,
)(ChatSidebarView);
